import { render } from "./App.vue?vue&type=template&id=16a8bb37"
const script = {}

import "./App.vue?vue&type=style&index=0&id=16a8bb37&lang=css"
script.render = render

export default script